import { LeadCreationResponse } from "@justhome/api-core";
import {
  EMAIL_PARAMETER,
  FIRST_NAME_PARAMETER,
  LAST_NAME_PARAMETER,
  LEAD_ID_PARAMETER,
  PHONE_PARAMETER,
} from "@justhome/common/constants";
import { useRouter } from "@lib/hooks/useRouter";
import { useMemo } from "react";

const isNonEmptyString = (
  value: string | string[] | undefined,
): value is string => typeof value === "string" && value.trim() !== "";

const useLeadFromQuery = (): LeadCreationResponse | null => {
  const router = useRouter();

  return useMemo(() => {
    if (!router.isReady) {
      return null;
    }

    const leadId = router.query[LEAD_ID_PARAMETER];
    if (!isNonEmptyString(leadId)) {
      return null;
    }

    const firstName = router.query[FIRST_NAME_PARAMETER];
    const lastName = router.query[LAST_NAME_PARAMETER];
    const email = router.query[EMAIL_PARAMETER];
    const phone = router.query[PHONE_PARAMETER];

    const lead: LeadCreationResponse = {
      id: leadId,
      disqualified: false,
      needsReconfirmation: false,
    };

    if (isNonEmptyString(firstName)) {
      lead.firstName = firstName;
    }
    if (isNonEmptyString(lastName)) {
      lead.lastName = lastName;
    }
    if (isNonEmptyString(email)) {
      lead.email = email;
    }
    if (isNonEmptyString(phone)) {
      lead.phone = phone;
    }

    return lead;
  }, [router.isReady, router.query]);
};

export default useLeadFromQuery;
